import { createApp, h } from 'vue'
import VideoModal from '../components/VideoModal.vue'

class VideoModalPlugin {
    constructor() {
        this.modalInstance = null
        this.container = null
    }

    install(app) {
        // Menambahkan method global untuk membuka modal video
        app.config.globalProperties.$videoModal = {
            open: (options) => this.open(options),
            close: () => this.close()
        }

        // Menambahkan method untuk inject di setup()
        app.provide('videoModal', {
            open: (options) => this.open(options),
            close: () => this.close()
        })
    }

    open(options = {}) {
        // Menutup modal yang sudah ada jika ada
        this.close()

        // Menyimpan referensi this untuk digunakan di dalam closure
        const self = this

        // Membuat container untuk modal
        this.container = document.createElement('div')
        this.container.id = 'video-modal-container'
        document.body.appendChild(this.container)

        // Membuat instance Vue untuk modal
        this.modalInstance = createApp({
            render() {
                return h(VideoModal, {
                    isOpen: true,
                    videoSrc: options.videoSrc || '',
                    title: options.title || '',
                    description: options.description || '',
                    onClose: () => {
                        console.log('Modal close event triggered')
                        self.close()
                    }
                })
            }
        })

        // Mount modal
        this.modalInstance.mount(this.container)
    }

    close() {
        console.log('Plugin close method called')

        if (this.modalInstance) {
            this.modalInstance.unmount()
            this.modalInstance = null
        }

        if (this.container) {
            if (document.body.contains(this.container)) {
                document.body.removeChild(this.container)
            }
            this.container = null
        }
    }
}

// Membuat instance plugin
const videoModalPlugin = new VideoModalPlugin()

export default videoModalPlugin

// Export composable untuk digunakan di setup()
export function useVideoModal() {
    return {
        openVideoModal: (options) => videoModalPlugin.open(options),
        closeVideoModal: () => videoModalPlugin.close()
    }
} 